module.exports = __webpack_public_path__ + "img/VTT_logo_grey.614f1f32.svg";